import { ProfileDto } from '@app/models/dtos/contentDto';

const profile: ProfileDto = {
    name: 'Nabin Kawan',
    role: 'Senior Software Engineer',
    tagline: 'Senior Software Engineer',
    intro: 'A script goes in, a finished film comes out. I build the machinery in between: prompting that plans each shot, pipelines that render for hours without losing their place, and an editor that stays quick at seven hundred shots.',
    location: 'Bhaktapur, Nepal',
    email: 'kawannabin@gmail.com',
    available: true,
    availabilityLabel: 'Open to work',
    socials: [
        { name: 'GitHub', handle: 'nabinkawan', link: 'https://github.com/nabinkawan' },
        { name: 'LinkedIn', handle: 'in/nabinkawan', link: 'https://www.linkedin.com/in/nabinkawan' }
    ]
};

export default profile;
